// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.live-data {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Session bar ── */
.live-session-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.live-session-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.live-pill {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(148, 163, 184, 0.1);
  color: #64748b;
  border: 1px solid transparent;
}

.live-pill.active {
  background: rgba(16, 185, 129, 0.15);
  color: #6ee7b7;
  border-color: rgba(16, 185, 129, 0.3);
}

.live-pill.ended {
  background: rgba(245, 158, 11, 0.1);
  color: #fbbf24;
}

.live-pill.upcoming {
  opacity: 0.4;
}

.live-session-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e2e8f0;
}

.live-ended-tag {
  color: #fbbf24;
  font-size: 0.8em;
  font-weight: 400;
}

.live-time-left {
  font-size: 0.82rem;
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}

.live-progress-bar {
  flex: 1 1;
  height: 4px;
  background: rgba(148, 163, 184, 0.15);
  border-radius: 99px;
  overflow: hidden;
  min-width: 60px;
}

.live-progress-fill {
  height: 100%;
  background: #6ee7b7;
  border-radius: 99px;
  transition: width 0.5s ease;
}

/* ── Driver table ── */
.live-table-wrap {
  overflow-x: auto;
}

.live-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
  color: #e2e8f0;
}

.live-table th {
  padding: 8px 10px;
  text-align: left;
  color: #64748b;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  white-space: nowrap;
}

.live-table td {
  padding: 9px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.07);
  font-size: 0.88rem;
  white-space: nowrap;
  vertical-align: middle;
}

.live-table .driver-row:hover td {
  background: rgba(148, 163, 184, 0.05);
}

.live-table .driver-row.row-left td {
  opacity: 0.45;
  font-style: italic;
}

.live-table .driver-row.row-expanded > td {
  background: rgba(99, 102, 241, 0.06);
  border-bottom-color: transparent;
}

/* Column widths */
.live-table .col-expand { width: 28px; padding: 0 4px; color: #64748b; }
.live-table .col-pos    { width: 42px; text-align: center; }
.live-table .col-num    { width: 52px; text-align: center; }
.live-table .col-best,
.live-table .col-last   { width: 90px; font-variant-numeric: tabular-nums; }
.live-table .col-laps,
.live-table .col-pits   { width: 52px; text-align: center; }
.live-table .col-status { width: 110px; }
.live-table .col-ev     { width: 36px; }

.live-collision {
  display: inline-flex;
  align-items: center;
  color: #fbbf24;
}

/* ── Lap expansion ── */
.laps-row > .laps-cell {
  padding: 0 !important;
  border-bottom: 2px solid rgba(99, 102, 241, 0.2) !important;
  background: rgba(15, 23, 42, 0.5);
}

.laps-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
  color: #cbd5e1;
}

.laps-table th {
  padding: 6px 14px;
  text-align: left;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(148, 163, 184, 0.08);
}

.laps-table td {
  padding: 6px 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.05);
  font-variant-numeric: tabular-nums;
  font-size: 0.82rem;
}

.laps-table tr.lap-collision td {
  color: #fbbf24;
}

/* ── States ── */
.live-empty {
  color: #64748b;
  text-align: center;
  padding: 40px;
  font-size: 0.9rem;
}

.live-data-error {
  color: #fca5a5;
  padding: 16px;
  font-size: 0.88rem;
  background: rgba(239, 68, 68, 0.08);
  border-radius: 8px;
  margin: 16px;
}

.live-data-loading {
  color: #64748b;
  padding: 24px;
  font-size: 0.88rem;
}

/* Light theme */
body.light-theme .live-session-label {
  color: #1e293b;
}

body.light-theme .live-table {
  color: #1e293b;
}

body.light-theme .live-table td {
  color: #1e293b;
}

body.light-theme .laps-table {
  color: #334155;
}

body.light-theme .laps-table td {
  color: #334155;
}

body.light-theme .laps-row > .laps-cell {
  background: rgba(248, 250, 252, 0.8);
}
`, "",{"version":3,"sources":["webpack://./src/components/LiveData.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB,0BAA0B,WAAW,EAAE,cAAc,EAAE,cAAc,EAAE;AACvE,0BAA0B,WAAW,EAAE,kBAAkB,EAAE;AAC3D,0BAA0B,WAAW,EAAE,kBAAkB,EAAE;AAC3D;0BAC0B,WAAW,EAAE,kCAAkC,EAAE;AAC3E;0BAC0B,WAAW,EAAE,kBAAkB,EAAE;AAC3D,0BAA0B,YAAY,EAAE;AACxC,0BAA0B,WAAW,EAAE;;AAEvC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,2DAA2D;EAC3D,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".live-data {\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n/* ── Session bar ── */\r\n.live-session-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.live-session-pills {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.live-pill {\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  background: rgba(148, 163, 184, 0.1);\r\n  color: #64748b;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.live-pill.active {\r\n  background: rgba(16, 185, 129, 0.15);\r\n  color: #6ee7b7;\r\n  border-color: rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.live-pill.ended {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  color: #fbbf24;\r\n}\r\n\r\n.live-pill.upcoming {\r\n  opacity: 0.4;\r\n}\r\n\r\n.live-session-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.live-ended-tag {\r\n  color: #fbbf24;\r\n  font-size: 0.8em;\r\n  font-weight: 400;\r\n}\r\n\r\n.live-time-left {\r\n  font-size: 0.82rem;\r\n  color: #94a3b8;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.live-progress-bar {\r\n  flex: 1;\r\n  height: 4px;\r\n  background: rgba(148, 163, 184, 0.15);\r\n  border-radius: 99px;\r\n  overflow: hidden;\r\n  min-width: 60px;\r\n}\r\n\r\n.live-progress-fill {\r\n  height: 100%;\r\n  background: #6ee7b7;\r\n  border-radius: 99px;\r\n  transition: width 0.5s ease;\r\n}\r\n\r\n/* ── Driver table ── */\r\n.live-table-wrap {\r\n  overflow-x: auto;\r\n}\r\n\r\n.live-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.88rem;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.live-table th {\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n  color: #64748b;\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-table td {\r\n  padding: 9px 10px;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.07);\r\n  font-size: 0.88rem;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n}\r\n\r\n.live-table .driver-row:hover td {\r\n  background: rgba(148, 163, 184, 0.05);\r\n}\r\n\r\n.live-table .driver-row.row-left td {\r\n  opacity: 0.45;\r\n  font-style: italic;\r\n}\r\n\r\n.live-table .driver-row.row-expanded > td {\r\n  background: rgba(99, 102, 241, 0.06);\r\n  border-bottom-color: transparent;\r\n}\r\n\r\n/* Column widths */\r\n.live-table .col-expand { width: 28px; padding: 0 4px; color: #64748b; }\r\n.live-table .col-pos    { width: 42px; text-align: center; }\r\n.live-table .col-num    { width: 52px; text-align: center; }\r\n.live-table .col-best,\r\n.live-table .col-last   { width: 90px; font-variant-numeric: tabular-nums; }\r\n.live-table .col-laps,\r\n.live-table .col-pits   { width: 52px; text-align: center; }\r\n.live-table .col-status { width: 110px; }\r\n.live-table .col-ev     { width: 36px; }\r\n\r\n.live-collision {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  color: #fbbf24;\r\n}\r\n\r\n/* ── Lap expansion ── */\r\n.laps-row > .laps-cell {\r\n  padding: 0 !important;\r\n  border-bottom: 2px solid rgba(99, 102, 241, 0.2) !important;\r\n  background: rgba(15, 23, 42, 0.5);\r\n}\r\n\r\n.laps-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.82rem;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.laps-table th {\r\n  padding: 6px 14px;\r\n  text-align: left;\r\n  color: #475569;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.08);\r\n}\r\n\r\n.laps-table td {\r\n  padding: 6px 14px;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.05);\r\n  font-variant-numeric: tabular-nums;\r\n  font-size: 0.82rem;\r\n}\r\n\r\n.laps-table tr.lap-collision td {\r\n  color: #fbbf24;\r\n}\r\n\r\n/* ── States ── */\r\n.live-empty {\r\n  color: #64748b;\r\n  text-align: center;\r\n  padding: 40px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.live-data-error {\r\n  color: #fca5a5;\r\n  padding: 16px;\r\n  font-size: 0.88rem;\r\n  background: rgba(239, 68, 68, 0.08);\r\n  border-radius: 8px;\r\n  margin: 16px;\r\n}\r\n\r\n.live-data-loading {\r\n  color: #64748b;\r\n  padding: 24px;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n/* Light theme */\r\nbody.light-theme .live-session-label {\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .live-table {\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .live-table td {\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .laps-table {\r\n  color: #334155;\r\n}\r\n\r\nbody.light-theme .laps-table td {\r\n  color: #334155;\r\n}\r\n\r\nbody.light-theme .laps-row > .laps-cell {\r\n  background: rgba(248, 250, 252, 0.8);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
